/** regex for ISO 8601 date strings */
export const ISO_DATE_REGEX = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z$/;

/** regex for hex color codes */
export const HEX_COLOR_REGEX = /^#[0-9a-fA-F]*$/;

/** regex for identifiers (alphanumeric, underscores, hyphens) */
export const IDENTIFIER_REGEX = /^[a-zA-Z0-9_-]+$/;

/** regex for simple identifiers (alphanumeric, underscores) */
export const SIMPLE_IDENTIFIER_REGEX = /^[a-zA-Z0-9_]+$/;

/** regex for dataset identifiers in the format "number:UPPERCASE_LETTERS_UNDERSCORES" */
export const DATASET_IDENTIFIER_REGEX = /^(\d+):([A-Z_]+)$/;